import { CryptoService } from 'app/shared/service/crypto.service';
import { Injectable } from '@angular/core';
import * as lzutf8 from 'scripts/lzutf8/0.6.3/lzutf8.min.js';

@Injectable()
export class CacheService {
    constructor(private cryptoService: CryptoService) { }

    save(options: LocalStorageSaveOptions) {
        // Set default values for optionals
        options.expirationMins = options.expirationMins || 0

        // Set expiration date in miliseconds
        const expirationMS = options.expirationMins !== 0 ? options.expirationMins * 60 * 1000 : 0

        const record = {
            value: typeof options.data === 'string' ? options.data : JSON.stringify(options.data),
            expiration: expirationMS !== 0 ? new Date().getTime() + expirationMS : null,
            hasExpiration: expirationMS !== 0 ? true : false
        }
        localStorage.setItem(options.key, lzutf8.encodeStorageBinaryString(lzutf8.compress(this.cryptoService.aesEncrypt(JSON.stringify(record), this.cryptoService.sha256(options.key)))));
    }

    load(key: string) {
        // Get cached data from localstorage
        const item = localStorage.getItem(key)
        if (item !== null) {
            let decItem;
            try {
                decItem = this.cryptoService.aesDecrypt(lzutf8.decompress(lzutf8.decodeStorageBinaryString(item)), this.cryptoService.sha256(key));
            } catch (err) {
                localStorage.removeItem(key);
                return null;
            }
            const record = JSON.parse(decItem)
            const now = new Date().getTime()
            // Expired data will return null
            if (!record || (record.hasExpiration && record.expiration <= now)) {
                return null
            } else {
                return JSON.parse(record.value)
            }
        }
        return null
    }

    remove(key: string) {
        localStorage.removeItem(key)
    }

    cleanLocalStorage() {
        localStorage.clear()
    }

    getLocalStorageSize() {
        let total = 0;
        for (let i = 0; i < localStorage.length; i++) {
            let key = localStorage.key(i);
            let value = localStorage.getItem(key);
            total += value.length;
        }
        return Number(total / 1024).toFixed(6);
    }
}

export class LocalStorageSaveOptions {
    constructor(key: string, data?: any, expirationMins?: number) {
        this.key = key;
        this.data = data;
        this.expirationMins = expirationMins;
    }
    key: string;
    data: any;
    expirationMins?: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/service/cache.service.ts